import { FunctionComponent } from 'react';
import {
    DatePicker as MuiDatePicker,
    DatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';

type DatePicker = Omit<
    DatePickerProps<Date, Date>,
    'inputFormat' | 'renderInput'
> & {
    error?: boolean;
    helperText?: string;
};

export const DatePicker: FunctionComponent<DatePicker> = ({
    error,
    helperText,
    ...props
}) => {
    return (
        <MuiDatePicker<Date>
            {...props}
            inputFormat='dd.MM.yyyy'
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        inputProps={{
                            ...params.inputProps,
                            placeholder: 'TT.MM.JJJJ',
                        }}
                        error={error}
                        helperText={helperText}
                        fullWidth
                    />
                );
            }}
        />
    );
};
